// src/features/rooms/pages/RoomDetailsPage/components/RoomHeader.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Chip } from '@mui/material';
import {
  Edit as EditIcon,
  CheckCircle as CheckCircleIcon,
  Block as BlockIcon,
} from '@mui/icons-material';
import { UUIDDisplay } from '../../../../../utils/formatters/uuid';
import { CLASSIFICATION_COLORS } from '../../../utils/classification_colors';

import PageHeader from '../../../../../components/common/PageHeader';

export default function RoomHeader({ room, canUpdate, onBack, onEdit }) {
  const { t } = useTranslation(['rooms', 'common']);

  return (
    <PageHeader
      onBack={onBack}
      title={room.name}
      badges={<>
        <Chip
          icon={room.is_active ? <CheckCircleIcon /> : <BlockIcon />}
          label={room.is_active ? t('rooms:status.active') : t('rooms:status.inactive')}
          size="small"
          color={room.is_active ? 'success' : 'warning'}
          variant="outlined"
        />
        <Chip
          label={t(`rooms:classifications.${room.classification}`)}
          size="small"
          color={CLASSIFICATION_COLORS[room.classification]}
          variant="outlined"
        />
      </>}
      subtitle={<>{t('common:labels.id')} <UUIDDisplay uuid={room.room_id} /></>}
      actions={canUpdate && (
        <Button
          variant="contained"
          startIcon={<EditIcon />}
          onClick={onEdit}
        >
          {t('rooms:actions.edit')}
        </Button>
      )}
    />
  );
}